import LocationCreateForm from "./location-create-form";
import LocationEditForm from "./location-edit-form";

const Forms = {
    LocationCreateForm : LocationCreateForm,
    LocationEditForm: LocationEditForm
};

export default Forms;